import React from "react";

function App() {
  return (
    <div className="contenedor">
      <h3>Política de privacidad de Preguntas Infinitas</h3>

      <ul>
        <li>
          <h4>Recopilación de información:</h4>
          <p>
            Preguntas Infinitas no recopila información personal identificable
            de sus usuarios.
          </p>
          <p>
            No solicitamos el inicio de sesión ni ningún tipo de información
            personal como nombre, dirección de correo electrónico o número de
            teléfono.
          </p>
        </li>

        <li>
          <h4>Datos recopilados automáticamente:</h4>
          <p>
            Durante el uso de la aplicación, se pueden recopilar datos de forma
            automática, como información sobre el rendimiento de la aplicación y
            estadísticas generales de uso.
          </p>
          <p>
            Estos datos se recopilan de manera anónima y se utilizan únicamente
            con fines de mejora y optimización de la aplicación.
          </p>
        </li>

        <li>
          <h4>Uso de cookies:</h4>
          <p>
            Preguntas Infinitas no utiliza cookies ni tecnologías similares para
            recopilar información de los usuarios.
          </p>
        </li>

        <li>
          <h4>Compartir información:</h4>
          <p>
            Preguntas Infinitas no comparte ninguna información personal ni
            datos recopilados con terceros.
          </p>
        </li>

        <li>
          <h4>Enlaces externos:</h4>
          <p>
            Preguntas Infinitas puede contener enlaces a sitios web externos o
            servicios de terceros. No somos responsables de las prácticas de
            privacidad o el contenido de estos sitios.
          </p>
        </li>
      </ul>

      <p>
        Ten en cuenta que esta política de privacidad se aplica únicamente a la
        aplicación PlayQuiz y no a otras aplicaciones o servicios que puedas
        acceder a través de enlaces o anuncios dentro de la aplicación.
      </p>

      <p>
        Si tienes alguna pregunta o inquietud relacionada con nuestra política
        de privacidad, no dudes en contactarnos a través de los canales de
        soporte proporcionados en la aplicación.
      </p>
    </div>
  );
}

export default App;
